import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  CardContent,
  IconButton,
  Dialog,
  Card,
  Grid,
  Chip, Menu, MenuItem, ListItemIcon, ListItemText, CircularProgress, Tooltip, Checkbox
} from "@material-ui/core";
import React, {useContext, useMemo, useState} from "react";
import ShowIf from "components/common/ShowIf";
import './style.scss';
import {Link} from 'react-router-dom';
import {GeneratedGameFavoriteButton} from "components/common/FavoriteButton";
import {ShareContextMenu} from "components/Sharing";
import DetailsPanelContext from "context/DetailsPanelContext";
import SocketContext from "context/SocketContext";
import CacheContext from "context/CacheContext";
import {addNewProject} from "pages/GDD3/Helpers";
import APIContext from "context/APIContext";
import {useHistory} from "react-router";
import WbIncandescentOutlinedIcon from "@mui/icons-material/WbIncandescentOutlined";
import {CloseOutlined, SearchOutlined} from "@mui/icons-material";
import {GeneratedImage} from "pages/GameGenerator";
import {IMAGE_TYPES, prepareGeneratedImage} from "pages/ImageGenerator";
import {GameIcon} from "components/common/GameCard";
import {FormTab, FormTabs} from "components/common/FormTabs";
import {Hint} from "scenes/Headquarters";
import MyButton from "components/Controls/MyButton";
import PerformanceUtils from "helpers/PerformanceUtils";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircle';
import CircleIcon from '@mui/icons-material/RadioButtonUnchecked';

const DEFAULT_OBJECT = {};

const generateImagesForGenerations = 'generateImagesForGenerations';

const NEW_GDD_MODAL = true;

const GeneratedGameCard = ({game, showGeneratedFrom = true, onGenerateImage, extraGameActions, onClick, actions}) => {

  const history = useHistory();
  const {call, loading} = useContext(APIContext);
  const {cache, setCache} = useContext(CacheContext);
  const [showLoading, setShowLoading] = useState(false);
  const [showCreateGDD, setShowCreateGDD] = useState(false);

  const {projects, gddComponents} = cache;
  const {title} = game;

  const image = useMemo(() => {
    if (game.image) return prepareGeneratedImage(game.image);
  }, [game.image]);

  async function onCopy() {
    await navigator.clipboard.writeText(game.description);
  }

  async function onSubmit(sections = [], useAI) {
    setShowCreateGDD(false);
    setShowLoading(true);

    if (!sections.find(({type}) => type === "summary")) {
      sections = [{type: "summary", n: 1}, ...sections];
    }

    let hasMoodboard = sections.find(({type}) => type === 'moodboard');

    let gdd2 = {
      art_style: game.image?.selected_style,
      genres: game.genres,
      sections: sections.map(({type, n}) => {
        let id = PerformanceUtils.generateId();
        const loading = useAI ? n : undefined;
        if (type === 'summary') {
          return {name: type, value: {text: game.description, title: game.title, id, _id: id}};
        } else if (type === 'moodboard') {
          return {name: type, id, _id: id, value: {images: game.image ? [game.image] : []}, loading};
        } else if (type === IMAGE_TYPES.art.value || type === IMAGE_TYPES.screenshot.value) {
          return {name: 'moodboard', value: {title: gddComponents[type].label, imageType: type}, id, _id: id, loading};
        } else {
          return {name: type, value: {}, id, _id: id, loading};
        }
      })
    };

    if (!hasMoodboard && game.image) {
      let id = PerformanceUtils.generateId();
      gdd2.sections.push({name: "moodboard", id, _id: id, value: {images: [game.image]}});
    }

    let project = await addNewProject(projects, call, setCache, game.platform, gdd2);
    if (project) {
      let path = {
        pathname: "/game-concept",
        state: {data: {generateImages: !!game.image, useAI}}
      }
      history.push(path);
    }
  }

  async function onClickConcept() {
    if (onClick) return onClick(game);

    if (NEW_GDD_MODAL) {
      setShowCreateGDD(true);
    } else {

      setShowLoading(true);

      let gdd2 = {
        art_style: game.image?.selected_style,
        genres: game.genres,
        sections: [
          {name: "summary", value: {text: game.description, title: game.title}},
        ]
      };
      if (game.image) {
        gdd2.sections.push({
          id: PerformanceUtils.generateId(),
          name: 'moodboard',
          value: {
            images: [game.image]
          }
        })
      }

      let project = await addNewProject(projects, call, setCache, game.platform, gdd2);
      if (project) {
        let path = {
          pathname: "/game-concept",
          state: {data: {generateImages: !!game.image}}
        }
        history.push(path);
      }
    }
  }

  return (
    <div className="generated-game-card animate__animated animate__fadeIn">
      {showCreateGDD && <NewGDDModal
        open={showCreateGDD}
        onClose={() => setShowCreateGDD(false)}
        game={game}
        onSubmit={onSubmit}
      />}
      <ShowIf condition={showLoading}>
        <div className="loading-wrapper">
          <CircularProgress size={45}/>
        </div>
      </ShowIf>
      <ShowIf condition={showGeneratedFrom}>
        <GeneratedFrom game={game}/>
      </ShowIf>
      <Card className="inner-card card-box position-relative" id={game.id}>
        <CardContent className="p-1">
          <Grid container direction="row" spacing={1}>
            <Grid
              container
              item sm={12}
              lg={12}
              xl={12}
              alignItems="flex-start" className="h-fit text-element">
              <GameActions game={game} actions={actions}>
                {extraGameActions}
              </GameActions>
              <Grid
                item
                md={12}
                sm={12}
                style={{gap: "20px", display: "flex", flexDirection: "column"}}
              >
                <div className="d-flex flex-row title-wrapper">
                  <span className="font-size-xxl font-weight-bold pt-0 title">
                    {title || "Untitled"}
                  </span>
                </div>
                <GeneratedImage
                  image={image}
                  imageProps={{hideActions: true}}
                  loading={loading[generateImagesForGenerations]}
                  onNewImage={onGenerateImage}
                />
                <GameInfo game={game}/>
                <Description game={game}/>
                <div className="buttons">
                  <Chip
                    onClick={onCopy}
                    className="copy-chip font-weight-bold w-fit no-background"
                    label="Copy to clipboard"
                  />
                  <div className="add">
                    <Chip
                      onClick={onClickConcept}
                      className="text-white font-weight-bold w-fit"
                      label="Select this idea"
                    />
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  )
};

const NewGDDModal = ({open, onClose, onSubmit}) => {

  const {cache} = useContext(CacheContext);
  const {gddComponents, componentGroups, gddPacks} = cache;

  const [tab, setTab] = useState(0);
  const [useAI, setUseAI] = useState(true);
  const [customOptions, setCustomOptions] = useState([
    {type: gddComponents.summary.section, n: 1}
  ]);

  const TABS = ["Choose Template", "Custom Sections"];

  function clickedCustom(option, n = 1) {
    if (option.section) {
      setCustomOptions(prevState => {
        let found = prevState.find(o => o.type === option.section);
        if (found) return prevState.filter(o => o.type !== option.section);
        return [...prevState, {type: option.section, n}];
      });
    }
  }

  function calculateCredits(sections = []) {
    return useAI ? Math.max(0, (sections.length - 1) * 0.5) : 0
  }

  const groups = useMemo(() => {
    return componentGroups.map(group => {
      return {
        ...group,
        components: group.components.filter(component => !component.hide && component.gameElements)
      }
    }).filter(group => group.components.length > 0);
  }, [componentGroups]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="new-gdd-modal"
    >
      <span className="large-title">
        Create Game Concept
        <Hint
          hint="Select how you first want to expand this idea and Ludo.ai will create and prefill a game concept document based on your selection"
          iconClassName="help"/>
      </span>
      <span className="top-right">
        <IconButton onClick={onClose}>
          <CloseOutlined
            className="font-size-xxxxl pointer text-white"
          />
        </IconButton>
      </span>
      <div className="new-gdd-modal-content">
        <FormTabs value={tab} className="mt-4 white">
          {TABS.map((value, index) => (
            <FormTab
              key={index}
              label={<span>{value}</span>}
              onClick={() => setTab(index)}
            />
          ))}
        </FormTabs>

        <div onClick={() => setUseAI(!useAI)} className="mb-4 pointer">
          <Checkbox
            checked={useAI}
            className="p-0 mr-2 white"
          />
          <span>
          Automatically fill up sections using Ludo's recommendations
          <Hint
            hint="Use Ludo's AI capabilities to generate content for the sections you select"
          />
        </span>
        </div>

        {tab === 0 && <div className="options">
          <Grid container spacing={2}>
            {gddPacks.map((option, index) => {
              const numberCredits = calculateCredits(option.components);
              return (
                <Grid item sm={12} md={6}>
                  <Tooltip
                    title={option.description}
                    arrow
                    PopperProps={{className: "MuiTooltip-popper MuiTooltip-popperArrow secondary"}}
                    placement="top"
                  >
                    <div className="option" onClick={() => onSubmit(option.components, useAI)}>
                      <div className="title-wrapper">
                        <span className="title">{option.title}</span>
                        <div><span className="credits">{numberCredits} credits</span></div>
                      </div>
                      <ul>{option.components?.map(({type}) => <li>{gddComponents[type]?.label || type}</li>)}</ul>
                    </div>
                  </Tooltip>
                </Grid>
              )
            })}
          </Grid>
        </div>}
        {tab === 1 &&
          <>
            <div className="checkboxes">
              <div className="group">
                      <span className="secondary-title">Game Presentation</span>
                <div className="options">
                  <Grid container spacing={2}>
                    <CheckboxOptions values={[gddComponents.summary]}
                                     customOptions={customOptions}
                    />
                  </Grid>
                </div>
              </div>
              {groups.map(group => {
                return (
                  <div className="group">
                      <span className="secondary-title">{group.title}<Hint hint={group.description}
                                                                           iconClassName="help"/></span>
                    <div className="options">
                      <Grid container spacing={0}>
                        <CheckboxOptions values={group.components}
                                         customOptions={customOptions}
                                         onClick={clickedCustom}
                                         max={6}
                        />
                      </Grid>
                    </div>
                  </div>
                )
              })}
              <div className="group">
                <span className="secondary-title">Standard Sections</span>
                <div className="options">
                  <Grid container spacing={0}>
                    <CheckboxOptions
                      values={[gddComponents.art, gddComponents.screenshot]}
                      customOptions={customOptions}
                      onClick={value => clickedCustom(value, 3)}
                      max={6}
                    />
                  </Grid>
                </div>
              </div>
            </div>
          </>
        }
      </div>
      {tab === 1 && <div className="custom-button-wrapper">
        <MyButton id="new-gdd-modal.create" color="secondary" onClick={() => onSubmit(customOptions, useAI)}>
          Create Game Concept
          <span className="credits">{calculateCredits(customOptions)} credits</span>
        </MyButton>
      </div>}
    </Dialog>
  )
}

const CheckboxOptions = ({values, customOptions, onClick, max}) => {
  return (
    values.map((value, index) => {

        let checked = !!customOptions.find(option => option.type === value.section);
        let disabled = !onClick;
        if (max && customOptions.length > 6 && !checked) disabled = true;

        return (
          <Grid item sm={12} md={6} key={index} onClick={onClick && !disabled ? () => onClick(value) : undefined}
                className="pointer">
            <Checkbox
              icon={<CircleIcon />}
              checkedIcon={<CheckCircleOutlineIcon/>}
              checked={checked}
              className="p-0 mr-2 white"
              disabled={disabled}
            />
            <span onClick={onClick}>{value.label}</span>
          </Grid>);
      }
    ));
}

export const GameActions = ({
                              game,
                              children,
                              actions = {favorite: true, more: true, generateSimilar: true},
                              afterClickedFavorite
                            }) => {

  const {track} = useContext(SocketContext);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  function trackWrapper(event, action) {
    track(action, {game});
  }

  function onActionsClose(event) {
    event.stopPropagation();
    event.preventDefault();
    setMenuAnchorEl(null);
  }

  function onActionsClick(event) {
    track('generated-game-card.open-context', {game});
    event.stopPropagation();
    event.preventDefault();
    setMenuAnchorEl(event.currentTarget);
  }

  return (
    <div className="game-actions mr-4">
      <GameContextMenu
        game={game}
        onClose={onActionsClose}
        anchor={menuAnchorEl}
        actions={actions}
      />
      <ShowIf condition={!!children}>
        {children}
      </ShowIf>
      <ShowIf condition={!!actions.favorite}>
        <GeneratedGameFavoriteButton game={game} afterClickedFavorite={afterClickedFavorite}/>
      </ShowIf>

      <ShowIf condition={!!actions.generateSimilar}>
      <Link
        to={{
          pathname: "/game-ideator",
          state: {data: {generated_game: game}}
        }}
        style={{display: "contents"}}
        onClick={event => trackWrapper(event, 'context.generated-game.generate')}
      >
        <Tooltip
          title="Generate based on this idea"
          arrow
          PopperProps={{className: "MuiTooltip-popper MuiTooltip-popperArrow secondary"}}
          placement="top"
        >
          <IconButton aria-label="generate based on this idea" className="text-primary more-actions">
            <WbIncandescentOutlinedIcon className="flip-vertical"/>
          </IconButton>
        </Tooltip>
      </Link>
      </ShowIf>

      <ShowIf condition={!!actions.more}>
        <IconButton aria-label="more actions" className="text-primary more-actions" onClick={onActionsClick}>
          <MoreVertIcon/>
        </IconButton>
      </ShowIf>
    </div>
  );
}

export const Description = ({game}) => {

  const splitDescription = useMemo(() => {
    return (game.description || "").split("\n\n");
  }, [game.description]);

  return (
    <div
      className="mb-1 description"
    >
      <ShowIf condition={splitDescription.length >= 2}>
        <span><b>{splitDescription[0]}</b></span>
        {splitDescription.slice(1).map(text => <span key={text}>{text}</span>)}
      </ShowIf>
      <ShowIf condition={splitDescription.length < 2}>
        <span>{game.description}</span>
      </ShowIf>
    </div>
  )
};

export const GeneratedFrom = ({game = DEFAULT_OBJECT}) => {

  const {track} = useContext(SocketContext);
  const {showGame} = useContext(DetailsPanelContext);

  async function onClickGame(game) {
    track('generated-game-card.clicked-generated-from-game', {game, blended_id: game._id})
    showGame(game);
  }

  let total = game.blended_games?.length;

  return (
    <ShowIf condition={game.blended_games?.length > 0}>
      <div className="blending-games" onClick={event => {
        event.stopPropagation();
        event.preventDefault();
      }}>
        {game.blended_games?.map((game, index) => {
          let includePlus = index < (total - 1);
          return (
            <React.Fragment key={game._id}>
              <Tooltip
                title={game.title}
                placement="top"
                PopperProps={{className: "MuiTooltip-popper MuiTooltip-popperArrow secondary"}}
              >
                <div onClick={() => onClickGame(game)}>
                  <ShowIf condition={!!game.icon}>
                    <GameIcon game={game} onClick={showGame}/>
                  </ShowIf>
                  <ShowIf condition={!game.icon}>
                    <div className="no-icon" onClick={() => showGame(game)}>{(game?.title || "").charAt(0)}</div>
                  </ShowIf>
                </div>
              </Tooltip>
              {includePlus ? <span className="plus">+</span> : null}
            </React.Fragment>
          )
        })}
      </div>
    </ShowIf>
  )
};

const GameInfo = ({game}) => {
  let {genres} = game;
  genres = genres || [];
  return (
    <ShowIf condition={genres.length > 0}>
      <div className="game-info">
        <div className="genres">{genres.map(genre => <Chip
          className="bg-blue"
          key={genre}
          size="small"
          label={genre}
        />)}</div>
      </div>
    </ShowIf>
  )
};

const GameContextMenu = ({game, onClose, anchor, actions = {}}) => {

    const {track} = useContext(SocketContext);

    function trackWrapper(event, action) {
      track(action, {game});
    }

    return (
      <Menu
        anchorEl={anchor}
        keepMounted
        open={!!anchor}
        onClose={onClose}
        key={game.id}
      >
        {!actions.generateSimilar && <MenuItem onClick={onClose}>
          <Link
            to={{
              pathname: "/game-ideator",
              state: {data: {generated_game: game}}
            }}
            style={{display: "contents"}}
            onClick={event => trackWrapper(event, 'context.generated-game.generate')}
          >
            <ListItemIcon>
              <WbIncandescentOutlinedIcon className="flip-vertical"/>
            </ListItemIcon>
            <ListItemText primary="Generate based on this idea"/>
          </Link>
        </MenuItem>}
        <MenuItem onClick={onClose}>
          <Link
            to={{
              pathname: "/search",
              state: {data: {generated_game: game}}
            }}
            style={{display: "contents"}}
            onClick={event => trackWrapper(event, 'context.generated-game.search-similar', true)}
          >
            <ListItemIcon>
              <SearchOutlined/>
            </ListItemIcon>
            <ListItemText primary="Search similar"/>
          </Link>
        </MenuItem>
        <MenuItem onClick={onClose}>
          <ShareContextMenu
            trackId="context.generated-game.share"
            trackOptions={{game}}
            data={{generated_game: game}}
          />
        </MenuItem>
      </Menu>
    )
  }
;

export default GeneratedGameCard;
